import React from 'react';
import { Alert } from '../../CommonComponents/OPL/Alert/Alert';
import { Box } from '../../CommonComponents/OPL/Box/Box';

interface Props {
  warningMessage: string;
  goToCashflow(): void;
}

const NegativeCashflowView: React.FC<Props> = ({ warningMessage, goToCashflow }) => {
  return (
    <Box mt="8" mb="40">
      <Alert
        variant="info"
        message={warningMessage}
        extraAction={{ text: 'Go To Projected Cash Flow', action: goToCashflow }}
      />
    </Box>
  );
};

export default NegativeCashflowView;
